/* eslint-disable  @typescript-eslint/no-explicit-any */
/* jscpd:ignore-start */
import axios from '@/plugins/axios'
import { Module } from 'vuex'

export interface Subscription {
    username: string
    token: string
}

const subscriptionModule: Module<any, any> = {
    state: {
        subscriptions: [],
        totalRows: 0,
    },

    actions: {
        // Add auth headers
        async UpdateSubscription({ dispatch }, subscription: Subscription) {
            await axios.post('/subscriptions', subscription)
            return await dispatch('GetSubscriptions')
        },

        async DeleteSubscription({ dispatch }, subscription: Subscription) {
            await axios.delete('/subscriptions', subscription)
            return await dispatch('GetSubscriptions')
        },

        async GetSubscriptions({ commit }, { page, num, search }) {
            // let response = await axios.get("/subscriptions");
            // Do some caching?

            const filterServerSide = false

            // cSpell:disable Fake up some data
 
            const subscriptionitems = [
                {
                    label: 'Social',
                    status: '150 of 200 Seats',
                    total: 500,
                },
                {
                    label: 'Newsletter',
                    status: 'Active',
                    total: 400,
                },
                {
                    label: 'SmartLink',
                    status: 'Active',
                    total: 500,
                },
                {
                    label: 'Lead Recon',
                    status: '150 of 150 Lookups',
                    total: 100,
                },
            ]
            // cSpell:enable

            const data = subscriptionitems
            const totalRows = subscriptionitems.length

            const response = {
                data: data,
                totalRows: totalRows,
            }

            const subscriptions = response.data

            let filteredSubscriptions = subscriptions

            if (search && search.length && !filterServerSide) {
                const searchLower = search.toLowerCase()
                filteredSubscriptions = subscriptions.filter((subscription) => {
                    return (
                        subscription.label.toLowerCase().indexOf(searchLower) >
                            -1 ||
                        subscription.status.toLowerCase().indexOf(searchLower) >
                            -1
                    )
                })
            }

            const indexFrom = (page - 1) * num
            let indexTo = num * page
            indexTo =
                indexTo < filteredSubscriptions.length
                    ? indexTo
                    : filteredSubscriptions.length
            const finalSubscriptions = filterServerSide
                ? filteredSubscriptions
                : filteredSubscriptions.slice(indexFrom, indexTo)

            commit('setSubscriptions', finalSubscriptions)
            commit('setTotalRows', response.totalRows)

            return finalSubscriptions
        },
    },

    mutations: {
        setSubscriptions(state: any, subscriptions) {
            state.subscriptions = subscriptions
        },
        setTotalRows(state: any, rows: number) {
            state.totalRows = rows
        },
    },
}

export default subscriptionModule
/* jscpd:ignore-end */
